import { format, parseISO } from "date-fns";
import { HealthWalletGapReasonType, ImmunizationType, ProcedureType, ProvenanceSource, VisitType, } from "healthex-common/health.wallet.dtos";
import { getObservableT, i18nGetDateFnsLocale } from "../Infra/i18next";
const t = getObservableT("patients");
const PROVENANCE_SOURCE_DISPLAY = {
    [ProvenanceSource.CLINICAL_RECORDS]: () => t("Clinical Records"),
};
export function provenanceSourceDisplay(source) {
    var _a, _b;
    return (_b = (_a = PROVENANCE_SOURCE_DISPLAY[source]) === null || _a === void 0 ? void 0 : _a.call(PROVENANCE_SOURCE_DISPLAY)) !== null && _b !== void 0 ? _b : source;
}
export function safeParse(raw) {
    if (raw === null || raw === "")
        return null;
    if (raw instanceof Date)
        return Number.isNaN(raw.getTime()) ? null : raw;
    const d = parseISO(raw);
    return Number.isNaN(d.getTime()) ? null : d;
}
export function formatDisplayDate(raw) {
    const d = safeParse(raw !== null && raw !== void 0 ? raw : null);
    if (!d)
        return "";
    const locale = i18nGetDateFnsLocale();
    return format(d, "LLL d, yyyy", locale ? { locale } : undefined);
}
export const FILTER_GROUP_VISITS = "visits";
export const FILTER_GROUP_PROCEDURE_DIAGNOSTIC = "procedure-diagnostic";
export const FILTER_GROUP_IMMUNIZATION = "immunization";
export const FILTER_ALL = "all";
export const TOP_ROW_CATEGORY_FILTER_IDS = [FILTER_GROUP_VISITS, FILTER_GROUP_PROCEDURE_DIAGNOSTIC, FILTER_GROUP_IMMUNIZATION];
export var HistoryCategory;
(function (HistoryCategory) {
    HistoryCategory["EMERGENCY"] = "EMERGENCY";
    HistoryCategory["PRIMARY_CARE"] = "PRIMARY_CARE";
    HistoryCategory["SPECIALIST"] = "SPECIALIST";
    HistoryCategory["URGENT_CARE"] = "URGENT_CARE";
    HistoryCategory["ANNUAL_PHYSICAL"] = "ANNUAL_PHYSICAL";
    HistoryCategory["CHIROPRACTIC"] = "CHIROPRACTIC";
    HistoryCategory["ACUPUNCTURE"] = "ACUPUNCTURE";
    HistoryCategory["PROCEDURE"] = "PROCEDURE";
    HistoryCategory["LAB_DRAW"] = "LAB_DRAW";
    HistoryCategory["IMAGING"] = "IMAGING";
    HistoryCategory["CARDIOLOGY"] = "CARDIOLOGY";
    HistoryCategory["PATHOLOGY"] = "PATHOLOGY";
    HistoryCategory["OTHER_DIAGNOSTIC"] = "OTHER_DIAGNOSTIC";
    HistoryCategory["VACCINATION"] = "VACCINATION";
    HistoryCategory["MENTAL_HEALTH"] = "MENTAL_HEALTH";
    HistoryCategory["DENTAL"] = "DENTAL";
    HistoryCategory["VISION"] = "VISION";
    HistoryCategory["OBSTETRICS"] = "OBSTETRICS";
})(HistoryCategory || (HistoryCategory = {}));
export const VISIT_TYPE_TO_CATEGORY = {
    [VisitType.PRIMARY_CARE]: HistoryCategory.PRIMARY_CARE,
    [VisitType.SPECIALIST]: HistoryCategory.SPECIALIST,
    [VisitType.ANNUAL_PHYSICAL]: HistoryCategory.ANNUAL_PHYSICAL,
    [VisitType.URGENT_CARE]: HistoryCategory.URGENT_CARE,
    [VisitType.EMERGENCY]: HistoryCategory.EMERGENCY,
    [VisitType.MENTAL_HEALTH]: HistoryCategory.MENTAL_HEALTH,
    [VisitType.PSYCHIATRY]: HistoryCategory.MENTAL_HEALTH,
    [VisitType.DENTAL]: HistoryCategory.DENTAL,
    [VisitType.VISION]: HistoryCategory.VISION,
    [VisitType.PHYSICAL_THERAPY]: HistoryCategory.CHIROPRACTIC,
    [VisitType.ALTERNATIVE_CARE]: HistoryCategory.ACUPUNCTURE,
    [VisitType.OBSTETRICS]: HistoryCategory.OBSTETRICS,
};
export const PROCEDURE_TYPE_TO_CATEGORY = {
    [ProcedureType.PROCEDURE]: HistoryCategory.PROCEDURE,
    [ProcedureType.LAB_DRAW]: HistoryCategory.LAB_DRAW,
    [ProcedureType.IMAGING]: HistoryCategory.IMAGING,
    [ProcedureType.CARDIOLOGY]: HistoryCategory.CARDIOLOGY,
    [ProcedureType.PATHOLOGY]: HistoryCategory.PATHOLOGY,
    [ProcedureType.OTHER_DIAGNOSTIC]: HistoryCategory.OTHER_DIAGNOSTIC,
};
export const IMMUNIZATION_TYPE_TO_CATEGORY = {
    [ImmunizationType.VACCINATION]: HistoryCategory.VACCINATION,
};
export const FILTER_OPTION_TO_CATEGORY = {
    "primary-care": HistoryCategory.PRIMARY_CARE,
    specialist: HistoryCategory.SPECIALIST,
    "urgent-care": HistoryCategory.URGENT_CARE,
    emergency: HistoryCategory.EMERGENCY,
    "annual-physical": HistoryCategory.ANNUAL_PHYSICAL,
    "mental-health": HistoryCategory.MENTAL_HEALTH,
    dental: HistoryCategory.DENTAL,
    vision: HistoryCategory.VISION,
    rehabilitation: HistoryCategory.CHIROPRACTIC,
    wellness: HistoryCategory.ACUPUNCTURE,
    "ob-gyn": HistoryCategory.OBSTETRICS,
    "lab-draw": HistoryCategory.LAB_DRAW,
    imaging: HistoryCategory.IMAGING,
    cardiology: HistoryCategory.CARDIOLOGY,
    pathology: HistoryCategory.PATHOLOGY,
    procedure: HistoryCategory.PROCEDURE,
    "other-diagnostic": HistoryCategory.OTHER_DIAGNOSTIC,
    vaccination: HistoryCategory.VACCINATION,
};
export function historyCategoryForFilterOption(optionId) {
    return FILTER_OPTION_TO_CATEGORY[optionId];
}
export function visitTypeDisplay(visitType) {
    var _a;
    const map = {
        [VisitType.PRIMARY_CARE]: t("Primary Care"),
        [VisitType.SPECIALIST]: t("Specialist"),
        [VisitType.ANNUAL_PHYSICAL]: t("Annual Physical"),
        [VisitType.URGENT_CARE]: t("Urgent Care"),
        [VisitType.EMERGENCY]: t("Emergency"),
        [VisitType.MENTAL_HEALTH]: t("Mental Health"),
        [VisitType.PSYCHIATRY]: t("Psychiatry"),
        [VisitType.DENTAL]: t("Dental"),
        [VisitType.VISION]: t("Vision"),
        [VisitType.PHYSICAL_THERAPY]: t("Rehabilitation"),
        [VisitType.ALTERNATIVE_CARE]: t("Wellness"),
        [VisitType.OBSTETRICS]: t("OB-GYN"),
    };
    return (_a = map[visitType]) !== null && _a !== void 0 ? _a : t("Visit");
}
export function procedureTypeDisplay(procedureType) {
    var _a;
    const map = {
        [ProcedureType.PROCEDURE]: t("Procedure"),
        [ProcedureType.LAB_DRAW]: t("Lab Draw"),
        [ProcedureType.IMAGING]: t("Imaging"),
        [ProcedureType.CARDIOLOGY]: t("Cardiology"),
        [ProcedureType.PATHOLOGY]: t("Pathology"),
        [ProcedureType.OTHER_DIAGNOSTIC]: t("Other Diagnostic"),
    };
    return (_a = map[procedureType]) !== null && _a !== void 0 ? _a : t("Procedure");
}
export function immunizationTypeDisplay(immunizationType) {
    var _a;
    const map = {
        [ImmunizationType.VACCINATION]: t("Immunization"),
    };
    return (_a = map[immunizationType]) !== null && _a !== void 0 ? _a : t("Immunization");
}
export function buildDismissReasonOptions() {
    return [
        { id: HealthWalletGapReasonType.RECORDS_DIDNT_TRANSFER, label: t("Records didn't transfer") },
        { id: HealthWalletGapReasonType.SAW_DIFFERENT_PROVIDER, label: t("Saw a different provider") },
        { id: HealthWalletGapReasonType.USED_TELEHEALTH, label: t("Used telehealth") },
        { id: HealthWalletGapReasonType.WAS_LIVING_ABROAD, label: t("Was living abroad") },
        { id: HealthWalletGapReasonType.NO_VISITS_DURING_THIS_TIME, label: t("No visits during this time") },
        { id: HealthWalletGapReasonType.SOMETHING_ELSE, label: t("Something else") },
    ];
}
